<template>
    <div>
            <vue-easy-print tableShow ref="easyPrint">
               <div class="img-box">
                  <div class="licenseNumber">车牌号:{{licenseNumber}}</div>
                <img :src="img" />
                </div>
            </vue-easy-print>
        <el-button style="float:right;margin-top:100px" @click="printBtn()">打印</el-button>
    </div>
</template>
<script>
import vueEasyPrint from 'vue-easy-print'
import { vehicleQrCode } from '@/api/driver'
export default {
    components: {
        vueEasyPrint,
    },
    data() {
        return {
            img: '',
            licenseNumber: '',
        }
    },
    created() {},
    methods: {
        getInfo(c, licenseNumber) {
            this.licenseNumber = licenseNumber
            vehicleQrCode({ vehicleCode: c }).then((response) => {
                this.img = response.msg
            })
        },
        printBtn() {
            this.$refs.easyPrint.print()
        },
    },
}
</script>
<style scoped>
.img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    position: relative;
    top:20%;
}
 .licenseNumber {
    font-size: 18px;
}
</style>
